import React from 'react';
import { Card, CardContent, CardActions, Skeleton, Box } from '@mui/material';
import { skeletonBg } from './skeletonStyles';

// Brand Loading & Busy-State Standard (999.2124): shapes mirror PlanCard
// (title, price, feature list, action button) so nothing jumps when plans
// arrive.

export default function PlanCardSkeleton() {
  return (
    <Card data-testid="plan-card-skeleton" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Skeleton variant="text" width="55%" height={32} sx={skeletonBg} />
        <Skeleton variant="text" width="35%" height={40} sx={[skeletonBg, { mb: 2 }]} />
        {[0, 1, 2, 3].map((i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Skeleton variant="circular" width={20} height={20} sx={skeletonBg} />
            <Skeleton variant="text" width={i % 2 ? '70%' : '85%'} sx={[skeletonBg, { flexGrow: 1 }]} />
          </Box>
        ))}
      </CardContent>
      <CardActions>
        <Skeleton variant="rectangular" width="100%" height={36} sx={[skeletonBg, { borderRadius: '2px' }]} />
      </CardActions>
    </Card>
  );
}
